export default "__VITE_PUBLIC_ASSET__f18bd3fb__"